// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__10f0A","validationTips":"StatementDescriptor_validationTips__20Xkk"};